import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { renderPartnerLogo, partnersContent } from './utils';

const SuccessPartnersSection = () => {
  const [currentLanguage, setCurrentLanguage] = useState('en');

  useEffect(() => {
    const savedLanguage = localStorage.getItem('memorial-language') || 'en';
    setCurrentLanguage(savedLanguage);

    // Listen for language changes
    const handleLanguageChange = (event) => {
      const newLanguage = event.detail?.language || 'en';
      setCurrentLanguage(newLanguage);
    };

    window.addEventListener('languageChanged', handleLanguageChange);
    return () => window.removeEventListener('languageChanged', handleLanguageChange);
  }, []);

  // Success Partners
  const successPartners = [
    {
      id: 1,
      name: "جمعية مشكاة الشبابية",
      logo: "/assets/logos/mishka.jpg",
      logoAlt: "جمعية مشكاة الشبابية - Mishkat Youth Voluntary Association logo"
    }
  ];

  const content = partnersContent?.[currentLanguage];

  return (
    <div id="success-partners">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, delay: 0.4 }}
        className="mb-24 lg:mb-32"
      >
        <h3 className="text-2xl md:text-3xl font-semibold text-primary text-center mb-6">
          {content?.successPartnersTitle}
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 items-center justify-items-center">
          {successPartners.map((item) => (
            <div key={item.id} className="text-center">
              {item.logo && item.logo !== "" ? (
                <div className={`flex items-center justify-center ${item.isLarge ? 'h-48' : 'h-40'}`}>
                  {renderPartnerLogo(item)}
                </div>
              ) : (
                <div className="text-lg md:text-xl">{item.name}</div>
              )}
            </div>
          ))}
        </div>
      </motion.div>
    </div>
  );
};

export default SuccessPartnersSection;

